<template lang="pug">
.document
  .document__content
    .document__title(:data-last-published="lastPublished")
      a(:target="result.openInNewWindow ? '_blank' : false",
        :href="result.url",
        :aria-label="ariaLabel"
      ) {{ result.title }}
    p.document__summary(v-html="result.summary")
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "SearchResultDocument",
  props: ["result"],
  computed: {
    ...mapGetters(["settings"]),
    ariaLabel() {
      return this.result.title ? "Click to go to " + this.result.title : '';
    },
    lastPublished() {
      const date = new Date(this.result.lastPublished);
      return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
    }
  },
};
</script>
<style lang="scss" scoped>
.document {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.25rem;
  width: 100%;
  margin: 0 0 1rem;
  padding: 0;
  border-bottom: 1px solid $lightGray;

  &:last-child {
    border-bottom: none;
  }

  @include mq(md) {
    flex-direction: row;
    align-items: center;
  }

  &__content {
    flex: 0 0 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    @include mq(md) {
      flex: 0 1 auto;
    }
  }

  &__title {
    padding: 0;
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;

    a {
      color: #5988b1;
      cursor: pointer;
    }

    p {
      margin-bottom: 0;
    }
  }

  &__meta {
    display: flex;
    margin: 0.5rem 0.5rem 0.5rem 0;
    font-size: 0.875rem;
    flex-wrap: wrap;
  }

  &__meta-item {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    color: $lightBlack;
    font-size: 0.875rem;
    &:not(:last-child) {
      &::after {
        content: "|";
        margin: 0 0.5rem;
        pointer-events: none;
        color: $gray;
      }
    }
    * {
      margin: 0 0.25rem;
      &:first-child {
        margin-left: 0;
      }
    }
  }

  &__summary {
    font-size: 1.1rem;
    margin: .25rem 0;
  }
}
</style>